'use client'

import { getMediaMimeType, Media } from '@/frontend/components/ui/media'
import { useState } from 'react'

const FeedbackSliderItem = ({ item }) => {
  const image = item.mediaGroupImage
  const mediaContent = getMediaMimeType(image?.media)
  const video = item.mediaGroupVideo.media
  const [openIndex, setOpenIndex] = useState(false)
  const sliderTextLength = 320

  const handleReadMoreClick = () => {
    setOpenIndex(!openIndex) // toggle openIndex state
  }

  const openVideoAsModal = (contentVideo) => {
    const modalContainer = document.createElement('div')
    modalContainer.classList.add('feedback-modal-container')

    modalContainer.innerHTML = `
      <button class="feedback-modal-close">Video Schließen</button>
      <video controls preload='true'>
        <source src="${contentVideo.url}" type="${contentVideo.mimeType}" />
      </video>
    `
    document.body.appendChild(modalContainer)

    const modalClose = modalContainer.querySelector('.feedback-modal-close')
    modalClose.addEventListener('click', () => {
      modalContainer.remove()
    })

    // close modal on escape key
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        modalContainer.remove()
      }
    })
  }

  return (
    <div className="feedback-item feedback-slide">
      <div className="author">
        {image ? (
          <div className="image">
            <Media mediaGroup={image} type={mediaContent} className="content-image" quality={90} />
          </div>
        ) : null}
        {item.name ? <div className="name">{item.name}</div> : null}
      </div>
      {item.heading ? <h3>{item.heading}</h3> : null}
      <div className="text">
        {openIndex ? (
          <div className="text-open">{item.text}</div>
        ) : (
          <div className="text-close">{item.text.slice(0, sliderTextLength)}...</div>
        )}
      </div>
      <div className="cta-container">
        {video ? (
          <button
            className="feedback-video-btn"
            onClick={(e) => {
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              e.preventDefault
              openVideoAsModal(video)
            }}
          >
            Zum Video
          </button>
        ) : null}
        {item.text.length > sliderTextLength ? (
          <button
            className={`read-more-btn ${openIndex ? 'active' : ''}`}
            onClick={(e) => {
              // eslint-disable-next-line @typescript-eslint/no-unused-expressions
              e.preventDefault
              handleReadMoreClick()
            }}
          >
            <span>{!openIndex ? 'Mehr lesen' : ' Weniger anzeigen'}</span>
            <svg className="read-more-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
              <path d="M11,4H13V16L18.5,10.5L19.92,11.92L12,19.84L4.08,11.92L5.5,10.5L11,16V4Z" />
            </svg>
          </button>
        ) : null}
      </div>
    </div>
  )
}

export default FeedbackSliderItem
